import { render, staticRenderFns } from "./service-tel.vue?vue&type=template&id=03de094a&scoped=true"
import script from "./service-tel.vue?vue&type=script&lang=js"
export * from "./service-tel.vue?vue&type=script&lang=js"
import style0 from "./service-tel.vue?vue&type=style&index=0&id=03de094a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03de094a",
  null
  
)

export default component.exports